import { render, staticRenderFns } from "./BadgeController.vue?vue&type=template&id=3c783b6c&scoped=true&"
import script from "./BadgeController.vue?vue&type=script&lang=js&"
export * from "./BadgeController.vue?vue&type=script&lang=js&"
import style0 from "./BadgeController.vue?vue&type=style&index=0&id=3c783b6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c783b6c",
  null
  
)

export default component.exports